"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Profile = void 0;
var React = require("react");
var core_1 = require("@blueprintjs/core");
var lodash_1 = require("lodash");
var Profile = (function (_super) {
    __extends(Profile, _super);
    function Profile() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showColumns: (0, lodash_1.fill)(Array(_this.props.fieldsByColumn.length), false)
        };
        return _this;
    }
    Profile.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var showColumns = this.state.showColumns;
        return (React.createElement(React.Fragment, null,
            React.createElement("article", { className: "b--black-20 bl br br2 bt animated fadeIn" },
                React.createElement("div", { className: "b--black-40 bb pa3" },
                    React.createElement("div", { className: props.titleClassName || 'f4 flex fw4 items-baseline justify-between tracked ttc' },
                        props.title,
                        props.toggleEditProfile ?
                            React.createElement(core_1.Button, { intent: core_1.Intent.PRIMARY, minimal: true, text: 'Edit', rightIcon: 'edit', onClick: props.toggleEditProfile })
                            : undefined),
                    React.createElement("div", { className: "black-70 f7 fw4 i lh-copy mt1 ttn" },
                        "updated: ",
                        props.updatedOn)),
                React.createElement("div", { className: "w-100" },
                    React.createElement("div", { className: "cf" }, props.fieldsByColumn.map(function (column, index) { return (column.value && React.createElement("div", { key: index, className: "b--black-50 bb fl ph2 ph3 pv2 w-100" },
                        React.createElement("p", { className: "flex items-baseline justify-between ma0" },
                            React.createElement("span", { className: "black-70 f5 fw5" },
                                column.title,
                                ": "),
                            React.createElement("span", { className: "black-60 dib f6 ml1" }, column.value)),
                        column.columns ?
                            React.createElement(core_1.Button, { className: "mt2", text: showColumns[index] ? "Hide ".concat(column.title) : "Show ".concat(column.title), onClick: function () { return _this.setState({
                                    showColumns: showColumns.map(function (value, idx) { return idx === index ? !value : value; })
                                }); } })
                            : undefined,
                        showColumns[index] && column.columns && column.columns.map(function (col, index) { return (React.createElement("div", { key: "col_".concat(index), className: "b--black-40 bb pa3" },
                            React.createElement("div", { key: "col_title_".concat(index), className: "f4 fw4 items-baseline justify-between tracked ttc" }, "".concat(index + 1)),
                            col.map(function (ch, idx) { return (React.createElement("div", { key: "".concat(ch.title, "_idx"), className: "b--black-50 bb fl ph2 ph3 pv2 w-100 mt2" },
                                React.createElement("p", { className: "flex items-baseline justify-between ma0" },
                                    React.createElement("span", { className: "black-70 f5 fw5" },
                                        ch.title,
                                        ": "),
                                    React.createElement("span", { className: "black-60 dib f6 ml1" }, ch.value)))); }))); }))); }))))));
    };
    return Profile;
}(React.Component));
exports.Profile = Profile;
//# sourceMappingURL=Profile.js.map